export enum AppRoutes {
  ROOT = '',
  EARLY_CHECK_IN = 'early-check-in',
  EARLY_CHECK_IN_RESERVATION_DETAILS = 'reservation-details',
  EARLY_CHECK_IN_DRIVER_DETAILS = 'driver-details',
  EARLY_CHECK_IN_DRIVER_LICENSE = 'driver-license',
  EARLY_CHECK_IN_DRIVER_ADDRESS = 'driver-address',
  EARLY_CHECK_IN_SUMMARY = 'summary',
  LINK_EXPIRED = 'link-expired',
  CHECK_IN_COMPLETED = 'check-in-completed',
  EXTERNAL_DESK = 'external-desk',
  EXTERNAL_DESK_CHECK_IN_RESERVATION_PREVIEW = 'check-in-reservation-preview',
  WIZARD_ORDER_NUMBER = 'order-number',
  GENERAL = 'general',
  GENERAL_HOME = 'home',
}

const buildRoute = (...segments: AppRoutes[]): string =>
  `/${segments.join('/')}`;

export const AppRoutePaths = {
  EARLY_CHECK_IN_RESERVATION_DETAILS: buildRoute(
    AppRoutes.EARLY_CHECK_IN,
    AppRoutes.EARLY_CHECK_IN_RESERVATION_DETAILS
  ),
  EARLY_CHECK_IN_DRIVER_DETAILS: buildRoute(
    AppRoutes.EARLY_CHECK_IN,
    AppRoutes.EARLY_CHECK_IN_DRIVER_DETAILS
  ),
  EARLY_CHECK_IN_DRIVER_LICENSE: buildRoute(
    AppRoutes.EARLY_CHECK_IN,
    AppRoutes.EARLY_CHECK_IN_DRIVER_LICENSE
  ),
  EARLY_CHECK_IN_DRIVER_ADDRESS: buildRoute(
    AppRoutes.EARLY_CHECK_IN,
    AppRoutes.EARLY_CHECK_IN_DRIVER_ADDRESS
  ),
  EARLY_CHECK_IN_SUMMARY: buildRoute(
    AppRoutes.EARLY_CHECK_IN,
    AppRoutes.EARLY_CHECK_IN_SUMMARY
  ),
  LINK_EXPIRED: buildRoute(AppRoutes.LINK_EXPIRED),
  CHECK_IN_COMPLETED: buildRoute(AppRoutes.CHECK_IN_COMPLETED),
  EXTERNAL_DESK_CHECK_IN_RESERVATION_PREVIEW: buildRoute(
    AppRoutes.EXTERNAL_DESK,
    AppRoutes.EXTERNAL_DESK_CHECK_IN_RESERVATION_PREVIEW///////////////////
  ),
  GENERAL_HOME: buildRoute(AppRoutes.GENERAL, AppRoutes.GENERAL_HOME),
} as const;